export default __webpack_public_path__ + "static/media/gallery-wip-emitter-body_04.14e1a41b.jpg";